import React from 'react';
import { useTranslation } from 'react-i18next';
import routes from '../../../router/routes';
import useQueryString from '../../../hooks/useQueryString';
import DictionaryList from '../../../containers/shared/DictionaryList';
import { useGetLanguagesQuery } from '../../../store/apis/dictionaries/languages';

const List = () => {
  const [t] = useTranslation();
  const { page = 1, pageSize = 20 } = useQueryString();
  const { data: language, isLoading, isFetching } = useGetLanguagesQuery({ page, pageSize });

  return (
    <DictionaryList
      title={t('Владение языками')}
      data={language?.results}
      dataCount={language?.count}
      loading={isLoading || isFetching}
      detailRoute={routes.languages}
    />
  );
};

export default List;
